class ControlsController {

  // constructor, set_state_toggle

  constructor() {
    this.$toggleButton = null;
    this.$filterButton = null; // tevens counter
    this.$filterPanel = null; // tevens counter
    this.$closeButton = null;
    this.filterStates = {
      'project-sector' : [],
      'project-expertise' : []
    };
  }

  set_state_toggle($elem) {
    this.$toggleButton = $elem; 
    this.$toggleButton.on('change', this.change_state )
  }

  set_filter_button($elem) {
    this.$filterButton = $elem; 
    this.$filterButton.on('click', this.filter_button_click.bind(this) );
  }

  set_close_button($elem) {
    this.$closeButton = $elem; 
    this.$closeButton.on('click', this.filter_button_click.bind(this) );
  }


  set_filter_panel($elem) {
    this.$filterPanel = $elem;
    this.$filterPanel.find('li').on('click', this.filter_click.bind(this) );
  }

  set_filter_button_counter() {
    let count = 0;
    let old_count = parseInt(this.$filterButton.html());
    if( window.werk.state == window.werk.FEATURED ) {
      count = jQuery('.grid-item.show-item[data-project-sector]').length;
    } else {
      count = jQuery('.project-list-item.show-filter').length;
    }
    if( count !== old_count ) {
      gsap.to( this.$filterButton, { 
        innerText : count,
        duration: 0.25,
        snap: {
          innerText : 1
        }
      })
      // this.$filterButton.html(count.toString());
    }
  }

  change_state(e) {
    e.preventDefault();
    let state = ( jQuery(this).prop('checked') )
      ? window.werk.ARCHIVE
      : window.werk.FEATURED;
    window.werk.set_state( state );
  }

  filter_button_click(e) {
    this.$filterPanel.toggleClass('show');
  }

  filter_click(e) {
    let $this = jQuery(e.currentTarget);
    if( !$this.hasClass('disabled') ) {

      let term_id = $this.attr('data-term');
      let taxonomy = $this.parent('ul').attr('data-taxonomy');

      if($this.hasClass('active')) {
        $this.removeClass('active');
        let i = this.filterStates[taxonomy].indexOf(term_id);
        this.filterStates[taxonomy].splice(i,1);
      } else {
        $this.addClass('active');
        this.filterStates[taxonomy].push(term_id);
      }

      let event = new CustomEvent('filters_changed', {
        detail : {
          filters : this.filterStates
        }
      });
      window.dispatchEvent(event);
      this.set_filter_button_counter();
    }
  }

}